import React from 'react';
import { Image } from 'react-bootstrap';
import shipment from './Shipment.jpg'
const Success = () => {
    return (
        <div>
            <Image src={shipment}/>
        </div>
    );
};

export default Success;